import { SimpleGrid, Box, Image } from "@chakra-ui/react"
import { StradePiazzeData } from "../data/stradePiazze"

const StradePiazzeComp = () => {
    return (
        <SimpleGrid columns={[1, null, 2, 3]} spacing='40px' mb={12} textColor='white'>

            {
                StradePiazzeData.map((data, index) => {
                    return (
                        <Box maxW='sm' borderRadius='lg' overflow='hidden' key={index} bgGradient={data.bgc} shadow='lg' position='relative' opacity='0.8'>
                            <Image
                                src={data.img}
                                alt='No image'
                                height='300px'
                                width='full'
                                objectFit='cover'
                            />

                            <Box
                                position='absolute'
                                top='0'
                                p={1}
                                rounded='sm'
                                bgColor='blackAlpha.400'
                                w='full'
                                textAlign='center'
                                shadow='md'
                            >
                                <Box
                                    fontWeight='bold'
                                    letterSpacing='wide'
                                    fontSize='xs'
                                    textTransform='uppercase'

                                >
                                    {data.shortDescription}
                                </Box>

                                <Box
                                    mt='1'
                                    fontWeight='semibold'
                                    as='h4'
                                    lineHeight='tight'
                                    noOfLines={1}
                                >
                                    {data.title}
                                </Box>
                            </Box>

                            <Box p='6'>
                                <Box
                                    mt='1'
                                    fontWeight='normal'
                                    as='h4'
                                    lineHeight='tight'
                                    textAlign='justify'
                                >
                                    {data.description}
                                </Box>
                            </Box>
                        </Box>
                    )
                })
            }
        </SimpleGrid>

    )
}

export default StradePiazzeComp